"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DraggablePropertyOption = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _underscore = require("underscore");

var _UITableHoverContent = _interopRequireDefault(require("UIComponents/table/UITableHoverContent"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _UIEditableControls = _interopRequireDefault(require("UIComponents/editable/UIEditableControls"));

var _UIAutosizedTextInput = _interopRequireDefault(require("UIComponents/input/UIAutosizedTextInput"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIDragHandle = _interopRequireDefault(require("UIComponents/draggable/UIDragHandle"));

var _reactDnd = require("react-dnd");

var _reactDndHtml5Backend = require("react-dnd-html5-backend");

var DraggablePropertyOption =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DraggablePropertyOption, _PureComponent);
  (0, _createClass2.default)(DraggablePropertyOption, null, [{
    key: "propType",
    get: function get() {
      return {
        option: _react.PropTypes.object.isRequired,
        selectedOptions: _react.PropTypes.array.isRequired,
        updatePreselected: _react.PropTypes.func.isRequired,
        updateLabel: _react.PropTypes.func.isRequired,
        removeOption: _react.PropTypes.func.isRequired,
        onReorder: _react.PropTypes.func.isRequired,
        onDrag: _react.PropTypes.func.isRequired,
        onDrop: _react.PropTypes.func.isRequired
      };
    }
  }]);

  function DraggablePropertyOption(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DraggablePropertyOption);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DraggablePropertyOption).call(this, props));
    _this.state = {
      label: props.option.label
    };
    _this.renderContent = _this.renderContent.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderPreSelectOption = _this.renderPreSelectOption.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleLabelChange = _this.handleLabelChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleLabelBlur = _this.handleLabelBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleLabelChange = _this.handleLabelChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(DraggablePropertyOption, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.connectDragPreview((0, _reactDndHtml5Backend.getEmptyImage)(), {
        captureDraggingState: true
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      this.setState({
        label: props.option.label
      });
    }
  }, {
    key: "handleLabelBlur",
    value: function handleLabelBlur() {
      var updateLabel = this.props.updateLabel;
      var label = this.state.label;
      updateLabel(label);
    }
  }, {
    key: "handleLabelChange",
    value: function handleLabelChange(_ref) {
      var value = _ref.target.value;
      this.setState({
        label: value
      });
    }
  }, {
    key: "renderPreSelectOption",
    value: function renderPreSelectOption() {
      var _this$props = this.props,
          updatePreselected = _this$props.updatePreselected,
          option = _this$props.option,
          selectedOptions = _this$props.selectedOptions;
      return _react.default.createElement(_UICheckbox.default, {
        "aria-label": option.value,
        checked: (0, _underscore.contains)(selectedOptions, option.value),
        onChange: updatePreselected
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props2 = this.props,
          option = _this$props2.option,
          isDragging = _this$props2.isDragging,
          removeOption = _this$props2.removeOption;
      var label = this.state.label;
      var draggingStyle = isDragging ? {
        opacity: 0
      } : {};
      return _react.default.createElement("tr", {
        style: draggingStyle
      }, _react.default.createElement(_UIDragHandle.default, null, _react.default.createElement("td", null, this.renderPreSelectOption())), _react.default.createElement("td", null, _react.default.createElement(_UISection.default, null, _react.default.createElement(_UIEditableControls.default, {
        open: false,
        className: "p-all-0 p-right-6",
        saveDisabled: false,
        saveOnEnter: true,
        use: "flush"
      }, _react.default.createElement(_UIAutosizedTextInput.default, {
        affordance: true,
        onChange: this.handleLabelChange,
        onBlur: this.handleLabelBlur,
        value: label
      })))), _react.default.createElement("td", null, option.value), _react.default.createElement("td", null, _react.default.createElement(_UITableHoverContent.default, null, _react.default.createElement(_UIButton.default, {
        size: "extra-small",
        use: "tertiary-light",
        onClick: removeOption
      }, _react.default.createElement(_FormattedMessage.default, {
        message: 'remove'
      })))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          connectDragSource = _this$props3.connectDragSource,
          connectDropTarget = _this$props3.connectDropTarget;
      return connectDragSource(connectDropTarget(this.renderContent()));
    }
  }]);
  return DraggablePropertyOption;
}(_react.PureComponent);

exports.DraggablePropertyOption = DraggablePropertyOption;
var SORTABLE_TYPE = 'SORTABLE_OPTION';
var Draggable = (0, _reactDnd.DragSource)(SORTABLE_TYPE, {
  beginDrag: function beginDrag(_ref2) {
    var option = _ref2.option,
        onDrag = _ref2.onDrag;
    onDrag();
    return {
      label: option.label,
      displayOrder: option.displayOrder,
      value: option.value
    };
  },
  isDragging: function isDragging(_ref3, monitor) {
    var option = _ref3.option;
    return option.value === monitor.getItem().value;
  },
  endDrag: function endDrag(_ref4) {
    var onDrop = _ref4.onDrop;
    onDrop();
  }
}, function (connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
    connectDragPreview: connect.dragPreview()
  };
});
var Droppable = (0, _reactDnd.DropTarget)(SORTABLE_TYPE, {
  hover: function hover(props, monitor) {
    var draggedValue = monitor.getItem().value;
    var droppedValue = props.option.value;

    if (draggedValue !== droppedValue) {
      props.onReorder(draggedValue, droppedValue);
    }
  }
}, function (connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
});

var _default = Droppable(Draggable(DraggablePropertyOption));

exports.default = _default;